import { AuthProvider } from '../Context/AuthContext';
import LoginForm from '../Components/LoginForm/LoginForm';

const Login = () => (
    <AuthProvider>
        <LoginForm />
    </AuthProvider>
);

export default Login;